import fetchApi from "../fetchApi";
export const RequestPasswordReset = async ({email}) => {

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "email": email,
        }),
        redirect: 'follow'
    }

    return await fetchApi('auth/forgot-password', options, true);

};
